<template>
    <div>
        <v-app-bar app color="secondary" dark clipped-left dense class="navbar">
        <v-img src="@/assets/logo.png" max-width="50" height="auto" />
        <p class="my-auto ml-3"> {{ $t('common.greenweb') }}</p>

        <v-spacer></v-spacer>

        <v-menu v-model="menu" :nudge-bottom="36" :nudge-left="305">
            <template v-slot:activator="{ on, attrs }">
               <v-icon size="26" class="mr-4" v-bind="attrs" v-on="on">mdi-account-circle</v-icon>
            </template>

            <v-card width="330px">
                <v-list>
                    <v-list-item >
                        <v-list-item-avatar color="secondary">
                            <v-icon dark>mdi-account</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content class="pb-0">
                            <v-list-item-title>{{
                                user.name
                            }}</v-list-item-title>
                            <v-list-item-subtitle>{{
                                user.email
                            }}</v-list-item-subtitle>
                            <p style="font-size: 12px" class="mt-3">
                                {{ $t('layout.version', { version: '2.7.0' }) }}
                            </p>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-divider></v-divider>

                <v-list dense>
                    <v-list-item @click="openProjectDialog = true">
                        <v-list-item-title>
                            {{ $t('layout.change_project') }}
                        </v-list-item-title>
                        <v-list-item-action>
                            <v-icon small>
                                mdi-swap-horizontal
                            </v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item @click="openColorDialog = true">
                        <v-list-item-title>
                            {{ $t('layout.change_color') }}
                        </v-list-item-title>
                        <v-list-item-action>
                            <v-icon small>
                                mdi-cog
                            </v-icon>
                        </v-list-item-action>
                    </v-list-item>

                    <v-list-group v-model="languageGroup" no-action @click.stop>
                        <template v-slot:activator>
                            <v-list-item class="pa-0">
                                <v-list-item-title>
                                    {{ $t("layout.change_language") }}
                                </v-list-item-title>
                            </v-list-item>
                        </template>
                        <template v-slot:appendIcon>
                            <v-list-item-action class="mr-0">
                                <v-icon small>mdi-translate</v-icon>
                            </v-list-item-action>
                        </template>
                        
                        <v-list-item-group v-model="selectedLanguage">
                            <v-list-item value="es" @click="setLanguage('es')">
                                <v-list-item-title class="pl-5 text-caption app-font">
                                    <span class="font-weight-bold mr-3"> ES </span>
                                    {{ $t('layout.spanish') }}
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item value="en" @click="setLanguage('en')">
                                <v-list-item-title class="pl-5 text-caption app-font">
                                    <span class="font-weight-bold mr-3"> EN </span>
                                    {{ $t('layout.english') }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list-group>

                        
                    <v-list-item @click="logout">
                        <v-list-item-title>
                             {{ $t('layout.log_out') }}
                        </v-list-item-title>
                        <v-list-item-action>
                            <v-icon small>
                                mdi-logout
                            </v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>
        <ProjectDialog
            :openDialog="openProjectDialog"
            @close="openProjectDialog = false"
        />
        <ColorDialog
            :openDialog="openColorDialog"
            @close="openColorDialog = false"
        />
    </v-app-bar>
    <v-snackbar v-model="showSnackbar" :timeout="3000" class="pr-0">
        {{ snackbarMessage }}
        <v-btn color="pink" text @click="showSnackbar = false"> {{ $t('common.close') }} </v-btn>
    </v-snackbar>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ColorDialog from './dialogs/ColorDialog.vue'
import ProjectDialog from './dialogs/ProjectDialog.vue';

export default {
    name: 'Toolbar',
    components: { 
        ColorDialog,
        ProjectDialog
    },
    computed: {
        ...mapState({
            user: (state) => state.user.data,
            language: (state) => state.app.language,
            userLanguages: (state) => state.project.attributes.userLanguages || [],
            userData: (state) => state.user.data,
        }),
    },
    data() {
        return {
            menu: false,
            openColorDialog: false,
            openProjectDialog: false,
            languageMenu: false,
            selectedLanguage: '',
            snackbarMessage: '',
            showSnackbar: false,
            languageGroup: false
        }
    },
    methods: {
        ...mapActions({
            doLogout: 'authentication/logout',
            set_language: 'app/set_language',
            updateAttributes: "project/updateAttributes"
        }),
        async logout() {
            await this.doLogout()
            this.$router.push({ name: 'login' })
            this.$vuetify.theme.themes.light.primary = '#06D676'
            this.$vuetify.theme.themes.light.secondary = '#023243'
        },
        async setLanguage(language) {
            try {
                this.snackbarMessage = ''
                this.menu = false
                const userLanguage = {id: this.userData._id, language}
                const userLanguages = this.userLanguages
                const index = userLanguages.findIndex((lang) => lang.id === userLanguage.id)
                const data = index !== -1 ? userLanguages.map((lang) => lang.id === userLanguage.id ? userLanguage : lang) : [...userLanguages, userLanguage]
                await this.updateAttributes({
                    name: "userLanguages",
                    data
                });
                this.set_language(language)
                if(this.$route.name !== 'home') this.$router.push({ name: 'home' })
            } catch {
                this.snackbarMessage = this.$t('messages.update.error', {item: this.$t('common.language').toLowerCase()})
                this.showSnackbar = true
            }
        }
    },
    mounted() {
        this.selectedLanguage = this.language
    },
    watch: {
        menu(val) {
            !val && (this.languageGroup = false)
        }
  }
}
</script>

<style scoped>
.navbar {
    z-index: 10000;
}

.v-list-group--active > .v-list-group__header > .v-list-group__header__append-icon .v-icon{
    transform: none !important;
  }
</style>
